import { FC, useCallback } from "react";
import { Button } from "@design-system/Button/Button";
import { useCommands } from "@components/commands/useCommands";
import { CommandsDirectory } from "@components/commands/lib";

interface Props {
    organizationId: string;
}

/**
 * Opens the app's shared "Add accounts" list, scoped to the organization: every
 * provider that can land accounts in this table connects without a client, and
 * the accounts are assigned to a client and entity afterwards.
 */
export const AddIntegrationTrigger: FC<Props> = ({ organizationId }) => {
    const { open } = useCommands();

    const openAccountsList = useCallback(() => {
        open(CommandsDirectory.ACCOUNTS, { organizationId });
    }, [open, organizationId]);

    return (
        <Button
            onClick={openAccountsList}
            variant="primary"
            size="md"
            data-testid="org-add-integration-btn"
        >
            Add account
        </Button>
    );
};
